import { SearchRepository, SearchService } from '@aipb/gulliver/catalog/data-access';
import { FacetContainerComponent } from '@aipb/gulliver/catalog/feature-facet';
import { ResultListComponent } from '@aipb/gulliver/catalog/feature-result-list';
import { ResultListMode, SearchItem } from '@aipb/gulliver/catalog/model';
import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { FormQueryComponent } from '@aipb/gulliver/catalog/ui';
import { DynamicGalleryEnvService } from '@aipb/gulliver/dynamic-gallery/env';
import { DynamicGalleryRouting } from '@aipb/gulliver/dynamic-gallery/routing';
import { EnvService } from '@aipb/gulliver/env/util';
import { ResolverService } from '@aipb/gulliver/resolver';
import { openUrl } from '@aipb/shared/util/routing';
import { SnackbarService } from '@aipb/shared/util/snackbar';
import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { MatDivider } from '@angular/material/divider';
import { EditSearchResultDialogService } from '../../dialogs';

@UntilDestroy()
@Component({
  selector: 'cat-result-item',
  templateUrl: './result-item.component.html',
  styleUrls: ['./result-item.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormQueryComponent,
    TranslocoModule,
    MatButtonModule,
    MatSidenavModule,
    FacetContainerComponent,
    ResultListComponent,
    MatIconModule,
    MatDivider
  ]
})
export class ResultItemComponent {
  @Input() item: SearchItem;
  private env = inject(EnvService);
  private searchService = inject(SearchService);
  private searchRepository = inject(SearchRepository);
  showFilters$: Observable<boolean> = this.searchRepository.showFilters$;
  resultListMode$: Observable<ResultListMode> = this.searchRepository.resultListMode$;
  private catalogRouting = inject(CatalogRouting);
  private catalogEnv = inject(CatalogEnvService);
  private snackbar = inject(SnackbarService);
  private resolverService = inject(ResolverService);
  private dynamicGalleryEnv = inject(DynamicGalleryEnvService);
  private dynamicGalleryRouting = inject(DynamicGalleryRouting);
  private editSearchResultDialogService = inject(EditSearchResultDialogService);

  get hasDynamicGallery() {
    return this.env.hasDynamicGallery;
  }

  get filterSidenavWidth() {
    return this.catalogEnv.env.filterSidenavWidth;
  }

  onToggleShowFacetList(): void {
    this.searchService.toggleShowFacetList();
  }

  onCopyResultSearch() {
    const url = new URL(this.catalogRouting.searchResultUrl());
    url.searchParams.set('q', this.item.search.q);
    url.searchParams.set('coreId', this.item.coreId);

    if (this.item.coordinates) {
      url.searchParams.set('coordinates', this.item.coordinates.join(','));
    }

    this.resolverService.copyUrl(url.toString()).subscribe(() => {
      this.snackbar.open('catalog.result.copy_search_query_msg', 'success');
    });
  }

  onOpenDynamicGallery(): void {
    const dynamicGalleryApi = this.dynamicGalleryEnv.env.apiUrl;
    const url = new URL(dynamicGalleryApi);
    url.searchParams.set('request', 'search');
    url.searchParams.set('coreId', this.item.coreId);
    url.searchParams.set('sort', this.item.search_sort.map((s) => `${s.field} ${s.dir} ${s.lang}`).join(','));

    const searchTab = this.searchRepository.getActiveTab();
    url.searchParams.set('q', this.searchRepository.getSearch(searchTab.id).search.q);
    url.searchParams.set('page', this.searchRepository.getSearch(searchTab.id).search.pageNum + '');

    const dynamicGalleryUrl = this.dynamicGalleryRouting.defaultAbsUrl(url.toString(), 'open-layers');

    openUrl(dynamicGalleryUrl);
  }

  onEditResultSearch(item: SearchItem) {
    this.editSearchResultDialogService.open({
      item
    });
  }
}
